/// <reference types="vite/client" />
import axios from 'axios'
import type { ApiResponse } from '../types'
import { setUsage, type UsageCategory } from '../store/usageStore'

export class ApiError extends Error {
  public readonly code: string

  constructor(code: string, message: string) {
    super(message)
    this.name = 'ApiError'
    this.code = code
  }
}

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
})

apiClient.interceptors.request.use((config) => {
  // Skip for FormData — let axios set multipart/form-data with boundary automatically
  if (!(config.data instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json'
  }
  return config
})

apiClient.interceptors.response.use((response) => {
  // Capture usage headers from tools / lab responses for the UsageWarningBanner.
  const remaining = parseInt(response.headers['x-usage-remaining'] ?? '', 10)
  const limit     = parseInt(response.headers['x-usage-limit'] ?? '', 10)
  if (!isNaN(remaining) && !isNaN(limit) && limit > 0) {
    const url      = response.config.url ?? ''
    const category: UsageCategory = url.includes('/lab/') ? 'api-lab' : 'tools'
    setUsage(remaining, limit, category)
  }

  const envelope = response.data as ApiResponse<unknown>

  if (!envelope.success) {
    throw new ApiError(envelope.error.code, envelope.error.message)
  }

  response.data = envelope.data
  return response
})

export default apiClient
